import { useState } from "react";
import { useMediaQuery, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import GreenButton from "../../../components/GreenButton/GreenButton";
import BlueButton from "../../../components/BlueButton/BlueButton";
import AddGif from "./../../../assets/add-gif.gif";
import MessageModals from "../../../components/MessageModals/MessageModals";

import ColorsGrid from "./ColorsGrid";
import SizesGrid from "./SizesGrid";
import WeightsGrid from "./WeightsGrid";
import SwipeableModals from "./SwipeableModals";
import usePermissions from "../../../hooks/usePermissions";

const ProductsView = () => {
  const { hasPermission } = usePermissions();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [productsView, setProductsView] = useState("colors");
  const [query, setQuery] = useState("");
  const [isSwipeableOpen, setIsSwipeableOpen] = useState(false);
  const [swipeableView, setSwipeableView] = useState("");
  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageView, setMessageView] = useState("");
  const [deleteMessage, setDeleteMessage] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [refreshData, setRefreshData] = useState(false);

  const handleDataRefresh = () => {
    setRefreshData((prev) => !prev); // Toggle to trigger useEffect
  };

  const handleOpenSwipeable = (view) => {
    setSwipeableView(view);
    setIsSwipeableOpen(true);
  };

  const handleOpenMessage = (view) => {
    setMessageView(view);
    setIsMessageOpen(true);
  };

  const getAddButtonText = () => {
    switch (productsView) {
      case "colors":
        return "اضافة لون جديد";
      case "sizes":
        return "اضافة حجم جديد";
      case "units":
        return "اضافة مقاس جديد";
      default:
        return "";
    }
  };

  const getCreateModalView = () => {
    switch (productsView) {
      case "colors":
        return "createColor";
      case "sizes":
        return "createSize";
      case "units":
        return "createUnit";
      default:
        return "";
    }
  };

  return (
    <div className="departments-container">
      <div className="actions-container">
        <div className="btns-container">
          <GreenButton
            text="الالوان"
            size={isMobile ? "full" : "medium"}
            variant={productsView === "colors" ? "fill" : "outlined"}
            onClick={() => setProductsView("colors")}
          />
          <GreenButton
            text="المقاسات"
            size={isMobile ? "full" : "medium"}
            variant={productsView === "units" ? "fill" : "outlined"}
            onClick={() => setProductsView("units")}
          />
          <GreenButton
            text="الاحجام"
            size={isMobile ? "full" : "medium"}
            variant={productsView === "sizes" ? "fill" : "outlined"}
            onClick={() => setProductsView("sizes")}
          />
        </div>
        {hasPermission(186) && (
          <BlueButton
            text={getAddButtonText()}
            size={isMobile ? "full" : isTablet ? "fit" : "large"}
            variant="fill"
            onClick={() => handleOpenSwipeable(getCreateModalView())}
            icon={<img src={AddGif} alt="" />}
          />
        )}
      </div>

      <div className="search">
        <TextField
          id="outlined-search"
          type="search"
          value={query}
          placeholder="ابحث..."
          onChange={(e) => setQuery(e.target.value)}
          sx={{
            width: isMobile ? "100%" : isTablet ? "300px" : "360px",
            borderRadius: "8px",
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>

      {productsView === "colors" && (
        <ColorsGrid
          refreshTrigger={refreshData} // Pass refresh trigger
          query={query}
          onEdit={(item) => {
            setSelectedItem(item);
            handleOpenSwipeable("editColor");
          }}
          onDelete={(item) => {
            setSelectedItem(item);
            handleOpenMessage("delete");
            setDeleteMessage("تم مسح اللون بنجاح");
          }}
        />
      )}

      {productsView === "sizes" && (
        <SizesGrid
          refreshTrigger={refreshData} // Pass refresh trigger
          query={query}
          onEdit={(item) => {
            setSelectedItem(item);
            handleOpenSwipeable("editSize");
          }}
          onDelete={(item) => {
            setSelectedItem(item);
            handleOpenMessage("delete");
            setDeleteMessage("تم مسح الحجم بنجاح");
          }}
        />
      )}

      {productsView === "units" && (
        <WeightsGrid
          refreshTrigger={refreshData} // Pass refresh trigger
          query={query}
          onEdit={(item) => {
            setSelectedItem(item);
            handleOpenSwipeable("editUnit");
          }}
          onDelete={(item) => {
            setSelectedItem(item);
            handleOpenMessage("delete");
            setDeleteMessage("تم مسح المقاس بنجاح");
          }}
        />
      )}

      <SwipeableModals
        open={isSwipeableOpen}
        onClose={() => {
          setIsSwipeableOpen(false);
          setSelectedItem(null);
        }}
        onOpen={() => setIsSwipeableOpen(true)}
        currentView={swipeableView}
        item={selectedItem}
        onSuccess={handleDataRefresh} // Add success callback
      />

      <MessageModals
        open={isMessageOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setSelectedItem(null);
          setDeleteMessage("");
        }}
        text={deleteMessage}
        currentView={messageView}
        route={`/variations/${selectedItem?.id}`}
        onDataChange={handleDataRefresh} // Add success callback
      />
    </div>
  );
};

export default ProductsView;
